

import React, { useEffect, useRef, useState } from "react";

const Healthabout = () => {
  const imageRef = useRef(null);
  const textRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (imageRef.current) observer.observe(imageRef.current);
    if (textRef.current) observer.observe(textRef.current);

    return () => {
      if (imageRef.current) observer.unobserve(imageRef.current);
      if (textRef.current) observer.unobserve(textRef.current);
    };
  }, []);

  return (
    <div className="healthabout-container">
      <style>
        {`
          .healthabout-container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 3rem 5%;
            background-color: white;
            flex-wrap: wrap;
            max-width: 100%;
            overflow-x: hidden;
          }
          
          .healthabout-text {
            width: 50%;
            padding: 0 0 0 2.5rem;
            text-align: left;
          }
          
          .healthabout-title {
            font-size: clamp(1.50rem, 3vw, 2rem);
            font-weight: bold;
            margin-bottom: 1.25rem;
            color: black;
            line-height: 1.2;
            letter-spacing:0px;
          }
          
          .healthabout-desc {
            font-size: clamp(0.9rem, 1.5vw, 1rem);
            line-height: 1.7;
            margin-bottom: 1rem;
            text-align: justify;
            color: black;
          }
          
          .healthabout-image-section {
            width: 45%;
            text-align: center;
          }
          
          .healthabout-image {
            width: 100%;
            max-width: 100%;
            height: auto;
            border-radius: 8px;
            display: block;
          }

          /* Animation styles */
          .slide-in-left {
            opacity: 0;
            transform: translateX(-50px);
            transition: all 0.8s ease-out;
          }
          
          .slide-in-right {
            opacity: 0;
            transform: translateX(50px);
            transition: all 0.8s ease-out;
          }
          
          .visible {
            opacity: 1;
            transform: translateX(0);
          }

          /* Responsive Design */
          /* Tablets and smaller desktops */
          @media (max-width: 1024px) {
            .healthabout-container {
              padding: 2.5rem 5%;
            }
            
            .healthabout-text {
              padding-left: 2rem;
            }
          }
          
          /* Large tablets and small laptops */
          @media (max-width: 992px) {
            .healthabout-text {
              padding-left: 1.5rem;
            }
          }
          
          /* Tablets */
          @media (max-width: 768px) {
            .healthabout-container {
              flex-direction: column;
              padding: 2rem 1.5rem;
            }
            
            .healthabout-text {
              width: 100%;
              padding: 0;
              order: 2;
              margin-top: 1.5rem;
            }
            
            .healthabout-image-section {
              width: 100%;
              order: 1;
              margin-bottom: 1.5rem;
            }
            
            .healthabout-title {
              text-align: center;
              margin-bottom: 1.5rem;
            }
            
            .healthabout-desc {
              text-align: left;
            }
            
            /* Adjust animation for mobile */
            .slide-in-left, .slide-in-right {
              transform: translateY(30px);
            }
            
            .visible {
              transform: translateY(0);
            }
          }
          
          /* Mobile devices */
          @media (max-width: 480px) {
            .healthabout-container {
              padding: 1.5rem 1rem;
            }
            
            .healthabout-title {
              margin-bottom: 1rem;
            }
            
            .healthabout-desc {
              line-height: 1.6;
              margin-bottom: 0.875rem;
            }
            
            .healthabout-image-section {
              margin-bottom: 1.25rem;
            }
          }
          
          /* Small mobile devices */
          @media (max-width: 360px) {
            .healthabout-container {
              padding: 1.25rem 0.875rem;
            }
            
            .healthabout-desc {
              text-align: left;
              hyphens: auto;
            }
          }
          
          /* High-resolution displays */
          @media (min-resolution: 120dpi) {
            .healthabout-image {
              transform: translateZ(0); /* Force GPU rendering for smoother animation */
            }
          }
          
          /* Reduced motion for accessibility */
          @media (prefers-reduced-motion: reduce) {
            .slide-in-left, .slide-in-right {
              transition: none;
              transform: none;
            }
          }
        `}
      </style>

      {/* Image Section */}
      <div
        ref={imageRef}
        className={`healthabout-image-section slide-in-left ${
          isVisible ? "visible" : ""
        }`}
      >
        <img
          src="/image/iStock-1300745916.webp"
          alt="Health Sciences and Technology"
          className="healthabout-image"
          loading="lazy"
        />
      </div>

      {/* Text Section */}
      <div
        ref={textRef}
        className={`healthabout-text slide-in-right ${
          isVisible ? "visible" : ""
        }`}
      >
        <h2 className="healthabout-title">
          Advancing Health Sciences Through Technology
        </h2>
        <p className="healthabout-desc">
          Basic health sciences form the foundation of medicine by studying the
          human body, its functions, and diseases. With the integration of
          technology, these sciences are evolving to provide faster, more
          accurate, and more accessible healthcare solutions.
        </p>
        <p className="healthabout-desc">
          From advanced diagnostic imaging, wearable health monitors, and
          telemedicine platforms to AI-driven data analysis, technology is
          reshaping how healthcare professionals study, diagnose, and treat
          patients. These innovations ensure early detection of diseases,
          personalized treatment plans, and improved patient outcomes.
        </p>
        <p className="healthabout-desc">
          At Envision, we believe that the future of health sciences lies in the
          synergy between biology, technology, and innovation. By leveraging
          tools like cloud-based health records, machine learning, and
          next-generation research platforms, we empower healthcare providers to
          deliver safe, efficient, and patient-centered care worldwide.
        </p>
      </div>
    </div>
  );
};

export default Healthabout;